export const MAP_MISSING_VALUES_LABELS = {
  low_engagement: 'L.E.',
  less_than_zero: '<0.01%',
  less_measure_value_than_zero: '<0.01',
  affinity_null: '-',
} as const;

export const MAX_TOP_SUB_CATEGORIES_COUNT = 8;

export const MAX_CUSTOM_FILTERS_COUNT = 5;

export const EXTERNAL_LINK =
  'https://www.helixa.ai/login?hsCtaTracking%3D7492886b-6594-4070-832e-b1bc83b5a99e%7C7016ff19-996e-4764-96d9-a0a478ff5843&sa=D&source=editors&ust=1653643389404926&usg=AOvVaw11HDl1kNwucvJLBLtBhl0R';

